module.exports = __webpack_public_path__ + "static/media/modal_maleta.a553fa33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/volumetric-options/modal_maleta.png
// module id = 1637
// module chunks = 0